import React from 'react';

import { Icon, makeUclComponent } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { Box, BoxProps, withTypography } from 'components/ui';
import { spacing } from 'styles/constants';

export const ErrorIcon = Icon.withConfig({
  name: 'mi:error',
  size: '$9',
});

const styles = StyleSheet.create({
  dialogIconContainer: {
    alignItems: 'center',
  },
  dialogTitle: {
    marginTop: spacing.$3,
  },
  dialogContent: {
    marginVertical: spacing.$3,
  },
  modalActionsContainer: {
    width: '100%',
  },
});

export const DialogIconContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.dialogIconContainer, style] });

export const DialogTitle = withTypography({
  variant: 'headerTwo',
  fontSize: '2xl',
  textAlign: 'center',
  lineHeight: 'lg',
  style: styles.dialogTitle,
});

export const DialogContent = withTypography({
  variant: 'copyOne',
  fontSize: 'md',
  textAlign: 'center',
  style: styles.dialogContent,
});

export const ConfirmButton = makeUclComponent(ActionButton).withConfig({
  fullWidth: true,
  variant: ActionButtonVariants.PRIMARY,
  marginBottom: '$3',
});

export const CloseButton = makeUclComponent(ActionButton).withConfig({
  fullWidth: true,
  variant: ActionButtonVariants.TEXT_ONLY,
});

export const ModalActionsContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.modalActionsContainer, style] });
